import React from "react";
import PropTypes from "prop-types";
import { Form, Button } from "antd";
import cx from "classnames";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { PDFIELDS } from "constants/form-fields";
import "styles/form.css";
import DocumentService from "services/documents-service";

const FormItem = Form.Item;

class PdDocumentUploadForm extends React.Component {
    state={
        selectedDocType: null,
        selectedFile: null
    };

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    onSelectDocType = (val) => {
        this.setState({
            selectedDocType: val,
        });
    }

    submitForm = () => {
        this.props.form.validateFields((err, values) => {
            let data = new FormData();
            data.append("file", values.document);
            data.append("file_name", values.document.name);
            data.append("company", this.props.companyId);
            DocumentService.uploadDocument(data).then((_) => {
                this.props.onSubmit({docType: this.state.selectedDocType, fileUrl: _.data && _.data.file});
            }).catch(() => {});
        });
    }

    render() {
        return (
            <Form className={cx("form", "br-3")} style={{overflow:"hidden"}}>
                <div className={"form-row"}>
                    {PDFIELDS.map((field, fieldName) => {
                        if(fieldName === "documentType") {
                            field.options = this.props.docTypes;
                            field.onSelect = this.onSelectDocType;
                        }    
                        if(fieldName === "docuement") {
                            field.onChange = this.onChange;
                        }
                        if(this.props.docTypes.length && !this.props.docTypes[0].label && fieldName === "documentType" ){
                            return ;
                        }
                        return this.fieldGenerator(
                            fieldName,
                            field,
                            this.getErrorOnField(fieldName)
                        )();
                    }).toList()}
                </div>
                <div className="d-flex justify-content-flex-end">
                    <FormItem className={cx("m-0")}>
                        <Button
                            type="primary"
                            onClick={this.submitForm}
                            icon={"plus"}
                        >
                            Add
                        </Button>
                    </FormItem>
                </div>
            </Form>
        );
    }
}

PdDocumentUploadForm.propTypes = {
    form: PropTypes.object,
    docTypes: PropTypes.array,
    onSubmit: PropTypes.func,
    companyId: PropTypes.number
};

export default Form.create({})(PdDocumentUploadForm);